import type { LooseCargoResponsibility } from '@chukua/common';

/** Display labels for `LOOSE_CARGO_RESPONSIBILITIES` — the loose cargo details form's loading/offloading responsibility selects. */
export const LOOSE_CARGO_RESPONSIBILITY_LABELS: Record<LooseCargoResponsibility, string> = {
  customer: 'Customer',
  us: 'Us',
  third_party: 'Third party',
};
